import { MIXPANEL_VENDOR_NAME } from "@/services/mixpanel/mixpanel-service";

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function onDidomiConsentChange(callback: Function) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).didomiEventListeners = (window as any).didomiEventListeners || [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).didomiEventListeners.push({
    event: "consent.changed",
    listener: async function () {
      await callback();
    },
  });
}

export function getMixpanelConsentOnDidomiReady(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).didomiOnReady = (window as any).didomiOnReady || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).didomiOnReady.push((Didomi: any) => {
      try {
        const hasUserAllowedTracking = Didomi.getUserStatus().vendors.consent.enabled.some(
          (consent: string) => consent === MIXPANEL_VENDOR_NAME,
        );
        resolve(hasUserAllowedTracking);
      } catch (error) {
        console.error("Error while trying to get Mixpanel consent on Didomi ready");
        reject(error);
      }
    });
  });
}
